export default __webpack_public_path__ + "static/media/valve_with_blue_bg.15f157cc.svg";